import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { PortalProvider } from "../../store/portal/PortalStoreContext";
import { useLanguageDirection } from "../../hooks";
import { createAppointmentTheme } from "../appointment/muiTheme";
import { useTheme as useMedosTheme } from "../../react/ThemeProvider";
import { PortalShell } from "./PortalShell";
export function PatientPortalWidget({ onError, maxWidth, maxHeight, defaultCountryCode, otpChannels, }) {
    const queryClientRef = useRef(null);
    if (!queryClientRef.current) {
        queryClientRef.current = new QueryClient({
            defaultOptions: {
                queries: {
                    retry: 1,
                    refetchOnWindowFocus: false,
                    staleTime: 30 * 1000,
                },
            },
        });
    }
    const direction = useLanguageDirection();
    const medosTheme = useMedosTheme();
    const muiTheme = useMemo(() => createAppointmentTheme(medosTheme), [medosTheme]);
    return (_jsx(QueryClientProvider, { client: queryClientRef.current, children: _jsxs(ThemeProvider, { theme: muiTheme, children: [_jsx(CssBaseline, {}), _jsx(Box, { dir: direction, sx: {
                        width: "100%",
                        maxWidth: maxWidth ?? 720,
                        maxHeight,
                        overflowY: maxHeight ? "auto" : undefined,
                        mx: "auto",
                        px: { xs: 1.5, sm: 2.5 },
                        py: { xs: 2, sm: 3 },
                        boxSizing: "border-box",
                        bgcolor: "background.default",
                        color: "text.primary",
                    }, children: _jsx(PortalProvider, { defaultCountryCode: defaultCountryCode, otpChannels: otpChannels, children: _jsx(PortalShell, { onError: onError, maxHeight: maxHeight }) }) })] }) }));
}
